const module = { name: 'fd-location/regionSelector', exports: {} }; const exports = module.exports;



import { Fandango_overlay as overlay } from 'base-libraries';



import { swig as swig } from 'require-core';



import { default as countrySwitcher } from 'swug-fdRequire-call:fd-location/countrySwitcher';



const REGION_OPTIONS = Object.freeze({
    GB: { label: 'United Kingdom' },
    IE: { label: 'Ireland' },
    US: { label: 'United States' },
})


const Selectors = {
    CANCEL_BTN: '.switch-region__btn--cancel',
    CONFIRM_BTN: '.switch-region__btn--confirm',
}
function showSwitchModal(currentCountry, targetCountry, opts) {
    const current = REGION_OPTIONS[currentCountry] || REGION_OPTIONS[countrySwitcher.getCurrentCountry()];
    const suggested = REGION_OPTIONS[targetCountry] || REGION_OPTIONS.US;
    const { onDismiss } = opts || {};
    const markup = swig.render('_switchRegion', {
        currentRegionName: current.label,
        locationName: suggested.label,
        suggestedRegionName: suggested.label,
    });
    const overlayInstance = overlay.open(markup, {
        disableCloseOnModalClick: true,
        overlayStyle: 'switch-region-overlay',
    });
    setTimeout(() => {
        if (!overlayInstance) {
            return;
        }
        const confirmBtn = overlayInstance.querySelector(Selectors.CONFIRM_BTN);
        const cancelBtn = overlayInstance.querySelector(Selectors.CANCEL_BTN);
        if (confirmBtn) {
            confirmBtn.addEventListener('click', () => countrySwitcher.switchCountry(targetCountry));
        }
        if (cancelBtn) {
            cancelBtn.addEventListener('click', () => {
                if (onDismiss) {
                    onDismiss();
                }
                overlay.close(overlayInstance);
            });
        }
        overlayInstance.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                if (onDismiss) {
                    onDismiss();
                }
                overlay.close(overlayInstance);
            }
        });
        if (confirmBtn) {
            confirmBtn.focus();
        }
    }, 100);
}
function onCountrySelect(e) {
    const { code } = e.detail || {};
    if (!code) {
        return;
    }
    const targetCountry = code.toUpperCase();
    if (!REGION_OPTIONS[targetCountry]) {
        return;
    }
    const currentCountry = countrySwitcher.getCurrentCountry();
    if (targetCountry === currentCountry) {
        return;
    }
    if (!countrySwitcher.isSameHost(targetCountry)) {
        showSwitchModal(currentCountry, targetCountry);
        return;
    }
    countrySwitcher.switchCountry(targetCountry);
}
function init() {
    document.addEventListener('brandbar:countrySelect', onCountrySelect);
}
module.exports = { init, showSwitchModal };
export default module.exports;